import { render } from "./MdIcon.vue?vue&type=template&id=796c6676&scoped=true"
import script from "./MdIcon.vue?vue&type=script&lang=js"
export * from "./MdIcon.vue?vue&type=script&lang=js"

import "./MdIcon.vue?vue&type=style&index=0&id=796c6676&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796c6676"]])

export default __exports__